import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { inviteCustomerRequest } from "../redux/actions/headNurse";
import { AppState } from "../redux/types";
import { ROLE } from "../utils/constants";
import RegisterCustomerForm from "./RegisterCustomerForm";
import UserInviteForm from "./UserInviteForm";
import { localePath } from "../i18n/config";

const UserEditForm = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const user = useSelector((state: AppState) => state.user);

    const handleInvite = (data: any) => {
        dispatch(inviteCustomerRequest(data, history));
    };

    useEffect(() => {
        if (user && (user.isAdmin || user.role === "it_support" || user.role === "head_nurse")) {
        } else {
            history.push(localePath("kirjaudu"));
        }
        return () => {};
    }, [dispatch, history, user]);

    // return <RegisterCustomerForm />;
    return user.role === ROLE.HEAD_NURSE ? (
        <div className='container'>
            <UserInviteForm onSendInvite={handleInvite} />
        </div>
    ) : (
        <RegisterCustomerForm />
    );
};

export default UserEditForm;
